import { LOAD_POPULAR_DATA, FILTER_PER_PAGE, CHANGE_PAGE } from './constants';

export function loadPopularData(payload, api) {
  return {
    type: LOAD_POPULAR_DATA,
    payload,
    api,
  };
}

export function changePerPage(value) {
  return {
    type: FILTER_PER_PAGE,
    value,
  };
}

export function changePage(page) {
  return {
    type: CHANGE_PAGE,
    page,
  };
}
